export const ENTERPRISE_CAPABILITY_META = [
  { key: 'crmAccess', label: 'Accès CRM', hint: 'Appels et consultation' },
  { key: 'crmManager', label: 'Gestion CRM', hint: 'Campagnes et supervision' },
  { key: 'hubupAccess', label: 'Accès Hubup', hint: 'Notifications' },
  { key: 'hubupManager', label: 'Gestion Hubup', hint: 'Profil public et réglages' },
  { key: 'teamManage', label: 'Équipe', hint: 'Invitations et rôles' },
];

export function activeCapabilities(role) {
  if (!role) return [];
  if (role.isSystemAdmin) {
    return ENTERPRISE_CAPABILITY_META.map((c) => c.key);
  }
  return ENTERPRISE_CAPABILITY_META.filter((c) => role[c.key] === true).map(
    (c) => c.key,
  );
}

export function capabilityLabels(role) {
  const keys = activeCapabilities(role);
  return ENTERPRISE_CAPABILITY_META.filter((c) => keys.includes(c.key)).map(
    (c) => c.label,
  );
}

export function emptyRoleDraft() {
  return {
    name: '',
    colorHex: '#6366f1',
    crmAccess: false,
    crmManager: false,
    hubupAccess: false,
    hubupManager: false,
    teamManage: false,
  };
}
